import { h, Component } from 'preact';
import 'style/global.scss';
import './app.scss';

import Header from 'components/header/header';
import Body from 'components/body/body';
import Footer from 'components/footer/footer';

export default class App extends Component{
  render(props, state){
    return (
      <div class='app'>
        <Header />

        <Body />

        <Footer />
      </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./components/app.jsx
 **/